<template>
  <div class="container page" style="background-color: #1f1c1f;">
    <van-nav-bar :title="$t('vote.record')" class="nav-bar">
      <template #left>
        <img src="/img/newLogin/download.png" @click="back()" style="width: 20px;height: 15px;"/>
      </template>
    </van-nav-bar>
  
    <div class="main">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty v-if="list.length === 0" :description="$t('vote.empty_data')" />
        <div v-else class="item_list" v-for="(v,key) in list" :key="key">
          <div class="lottery_info">
            <!-- <van-image class="cover" :src="v.ico">
              <template v-slot:loading>
                <van-loading type="spinner"/>
              </template>
            </van-image> -->
            <span class="period-number">{{v.expect}}</span>
            <!-- <span class="period-number">{{v.lottery_name}}</span> -->
          </div>
          <!-- <div class="recent">
            <div class="kuaisan-ball left">
              <div>
                <span>{{$t("vote.selection")}}：</span>
                <span class="ressquareBox">{{ calcSize(v.type) }}</span>
              </div>
            </div>
          </div> -->
          <div class="topInfo">
            <span v-if="v.is_win === 1" style="color: #07c160">{{v.win_text}}</span>
            <span v-else>{{v.win_text}}</span>
            <span>{{$t("vote.amount")}}：{{v.money}}</span>
          </div>
          <div class="time">
            <span>{{$t("vote.vote_time")}}：{{v.create_time}}</span>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list: []
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
      }, 500);
    },
    calcSize(el){
      if(el == "A"){
        return this.$t('lottery.heart');
      }
      if(el == "B"){
        return this.$t('lottery.rocket');
      }
      if(el == "C"){
        return this.$t('lottery.rose');
      }
      if(el == "D"){
        return this.$t('lottery.lily');
      }
      return el;
    },
    getVoteList(){
      this.$http({
        method: 'get',
        url: 'user_get_vote_list'
      }).then(res=>{
        if(res.code === 200){
          // const lanng = localStorage.getItem("lang");
          let list = res.data || [];
          list.map(item => {
            // if(item.lottery_name){
            //   const parts = item.lottery_name.split('|');
            //   // if(parts.length === 1){
            //   //   item.lottery_name = parts[0];
            //   // }else{
            //   //   item.lottery_name = lanng == 'zh' ? parts[0] : lanng == 'en' ? parts[1] : lanng == 'ja' ? parts[2] : parts[3];
            //   // }
            // }
            item.win_text = item.is_win == 1 ? this.$t('win') : this.$t('lose');
          })
          this.list = list;
        }else if(res.code === 401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getVoteList();
    }
  },
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}
.container .main{
  position: relative;
  overflow: auto;
  background-color: #1f1c1f;
  height: 100%;
  padding: 0 10px;
}
.item_list{
  padding: 15px 15px;
  margin: 30px 10px;
  background: linear-gradient(120deg, #212121, #313131);
  border-radius: 10px;
  line-height: 60px;
  color: #f3c7a2;
  border: 1px solid #766350;
}

.item_list .topInfo span{
  flex: 1;
  font-size: 32px;
  font-weight: 700;
  color: #f3c7a2;
}
.item_list .time span{
  flex: 1;
  font-size: 25px;
  font-weight: 500;
  color: #f3c7a2;
}

.item_list .cover{
  width: 60px;
  height: 60px;
  -o-object-fit: cover;
  object-fit: cover;
}
.item_list  .period-number{
  // margin-left: 50px;
  margin-right: 10px;
  height: 50px;
  line-height: 60px;
  font-size: 35px;
  font-weight: 700;
  color: #f3c7a2;
}
.item_list .lottery_info{
  display: flex;
}
.recent {
  display: flex;
  align-items: center;
  height: 100px;
}
.kuaisan-ball .left{
  justify-content: flex-start;
}
.kuaisan-ball{
  flex: 1;
  display: flex;
  align-items: center;
}

.kuaisan-ball .res-img{
  width: 70px;
  height: 70px;
  margin-right: 30px;
}
.kuaisan-ball .res-des{
  font-weight: 700;
  text-align: center;
  color: #f3c7a2;
}
.kuaisan-ball .res-des.middle{
  width: 15%;
  font-size: 35px;
}
.ressquareBox{
  background: linear-gradient(#fde3ca, #e7b486);
    color: #333;
    height: 7vw;
    line-height: 7vw;
    text-align: center;
    font-size: 3vw;
    font-weight: 700;
    border-radius: 16px;
    margin-left: 20px;
    padding: 13px 40px;
    min-width: 13vw;
    white-space: nowrap;
}
</style>
